let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("c6MKV"), load("aZinD"), load("cqZpg")]).then(() => parcelRequire('iWqmE'));